// Carnivoro loyalty validator — client-side sanity checks.
//
// IMPORTANT: client-side validation is NOT security. Anyone with DevTools can
// bypass it. Real protection must live server-side (Shopify App Proxy or
// Cloudflare Worker). This file's job is to reject the 90% of lazy tampering
// and obvious bugs before a result is even submitted.

'use strict';

var scoring = (typeof require !== 'undefined')
  ? require('./scoring.js')
  : (typeof window !== 'undefined' ? window.CarnivoroScoring : null);

var C = scoring.CONSTANTS;

function validateGameResult(gameData) {
  // gameData shape (produced by carnivoro-game.js at endGame):
  // {
  //   rawScore:     number,
  //   durationMs:   number,
  //   levelReached: number (0-9),
  //   itemsCaught:  number,
  //   itemsMissed:  number,
  //   maxStreak:    number,
  //   clientTs:     number (Date.now())
  // }

  var errors = [];

  if (!gameData || typeof gameData !== 'object') {
    return { ok: false, errors: ['missing gameData'] };
  }

  var raw = Number(gameData.rawScore);
  var dur = Number(gameData.durationMs);
  var level = Number(gameData.levelReached);
  var caught = Number(gameData.itemsCaught);

  if (!isFinite(raw) || raw < 0) errors.push('invalid rawScore');
  if (!isFinite(dur) || dur < 0) errors.push('invalid durationMs');

  // Duration floor: < 15s cannot produce a legit score.
  if (dur < 15000) errors.push('duration below 15s floor');

  // Force-end ceiling: game must end at or before 3 minutes.
  if (dur > C.FORCE_END_MS + 2000) errors.push('duration exceeds force-end');

  // Rate ceiling: pts/sec must be human.
  var ptsPerSec = dur > 0 ? (raw / (dur / 1000)) : Infinity;
  if (ptsPerSec > C.MAX_PTS_PER_SEC) {
    errors.push('pts/sec ' + ptsPerSec.toFixed(1) + ' exceeds ceiling ' + C.MAX_PTS_PER_SEC);
  }

  // Consistency: raw score must be achievable given items caught.
  // In the catch game, max possible per item (carnivoro x2 * streak x3) ~ 120 pts.
  if (isFinite(caught) && caught >= 0 && raw > caught * 150) {
    errors.push('rawScore inconsistent with itemsCaught');
  }

  // Level gating: level N requires cumulative XP, which requires real playtime.
  if (isFinite(level) && level > 0 && dur < (level * 8000)) {
    errors.push('level ' + level + ' unreachable in ' + dur + 'ms');
  }

  if (errors.length) return { ok: false, errors: errors };
  return { ok: true, errors: [] };
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { validateGameResult: validateGameResult };
} else if (typeof window !== 'undefined') {
  window.CarnivoroValidator = { validateGameResult: validateGameResult };
}
